const brokereeTypes = {
  INVESTOR: 'investor',
  MANAGER: 'manager',
};

export { brokereeTypes };
